import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import DataTable from "react-data-table-component";
import { Filter, Download } from "react-feather";
import { Dropdown } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import ReportNavbar from "./AdminComp/ReportNavbar";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import { Spinner } from 'react-bootstrap';
import { Link } from "react-router-dom";  

const ApproveListing = () => {
  const [listings, setListings] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch pending seller listings from API
  useEffect(() => {
    const fetchPendingListings = async () => {
      try {
        const response = await axios.get(`${baseurl}getPendingSellerListings`);
        console.log("📥 API Response:", response);

        if (response.data.success) {
          setListings(response.data.data);
          setFilteredData(response.data.data); // Initialize filteredData
        }
      } catch (error) {
        console.error("❌ Error fetching pending listings:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPendingListings();
  }, []);

  // Define table columns
  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: "Title",
      selector: (row) => row.title,
      sortable: true,
    },
    {
      name: "Condition",
      selector: (row) => row.condition,
      sortable: true,
    },
    {
      name: "Created At",
      selector: (row) => new Date(row.created_at).toLocaleString(),
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => (
        <Link
          to={`/admin/seller-listing-details/${row.id}`}
          className="btn btn-primary btn-sm"
          // target="_blank"
        >
          View Details
        </Link>
      ),
      button: true,
    },
  ];

  // Handle Excel Download
  const handleDownloadExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Pending Seller Listings");
    XLSX.writeFile(wb, "pending_seller_listings.xlsx");
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />

      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="text-start">Pending Seller Listings Approval</h4>
            <div className="d-flex align-items-center">
              <input
                type="text"
                className="form-control me-2"
                placeholder="Search Listings"
                onChange={(e) =>
                  setFilteredData(
                    listings.filter((listing) =>
                      listing.title.toLowerCase().includes(e.target.value.toLowerCase())
                    )
                  )
                }
              />
              <Dropdown className="me-2">
                <Dropdown.Toggle className="form-control prwcl" id="dropdown-basic">
                  <Filter size={16} /> Status Filter
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setFilteredData(listings)}>All</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              <span className="btn btnsuccess" onClick={handleDownloadExcel}>
                <Download size={17} />&nbsp;Download
              </span>
            </div>
          </div>

          <div className="card">
            <div className="card-body" style={{ padding: 0 }}>
              <div style={{ overflowX: "auto", maxHeight: "400px" }}>
                {loading ? (
                  <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
                    <Spinner animation="border" role="status">
                      <span className="sr-only">Loading...</span>
                    </Spinner>
                  </div>
                ) : (
                  <DataTable
                    columns={columns}
                    data={filteredData}
                    pagination
                    highlightOnHover
                    responsive
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApproveListing;
